export const RESPONSIVE_VIEW = 'RESPONSIVE_VIEW';
// The values of the next constants are alse used as part of classnames
export const SMARTPHONE_RESPONSIVE_VIEW = 'smartphone';
export const TABLET_RESPONSIVE_VIEW = 'tablet';
export const DESKTOP_RESPONSIVE_VIEW = 'desktop';
export const DEFAULT_VIEW = 'default';

export const showResponsiveView = value => ({ type: RESPONSIVE_VIEW, value });
export const closeResponsiveView = () => ({ type: RESPONSIVE_VIEW });




// WEBPACK FOOTER //
// ./src/actions/responsive.js